import { Field, FieldWrapper } from '@progress/kendo-react-form';
import React from 'react'; 
import { CusFormComboBox, CusFormInput,CusFormLabel, FormSubTitleTooltip} from '../validation/Form-Components';
import appDetailsData from '../data/persondetailsdata.json';
import { emailValidator, mobileNoValidator, reqDDLValidator } from '../validation/Validators';

const PersonContactDetails = (props) => {

    const{ seq ,fProps,holders,showAuthPerDDL, ...oth} = props;


    return(
        <div>
            {showAuthPerDDL &&
            <FieldWrapper>
                <Field leftLabelId={'lbl'+seq} leftLabelName={appDetailsData.authPerDDL.lblname}
                    id={'authPerCbo'} name={'authPerCbo'}
                    component={CusFormComboBox} textField={'Person_Name'}
                    disabled={false}
                    data={holders} placeholder={'Please select'} validator={reqDDLValidator} />
            </FieldWrapper>
            }

            <Field component={FormSubTitleTooltip} 
                id={'fstContactDetails'+seq} name={appDetailsData.formSubTitle.ST1}
                tooltipPosition={'right'} tooltipAchor={'target'} 
                tooltipTitle={appDetailsData.tooltipText.ST1}/>  
          
            <Field component={CusFormLabel} 
                leftLabelId={'lblCC'+seq} leftLabelName={appDetailsData.label.cc}
                id={'cc'+seq} name={'+65 Singapore'}/>
         
            <Field component={CusFormInput} 
                leftLabelId={'lblmno'+seq} leftLabelName={appDetailsData.label.mno} 
                id={'mno'+seq} name={'mno'+seq} placeholder={'Please input'} maxLength={8} 
                disabled={oth.disabled}
                validator={mobileNoValidator} />
         
            <Field component={CusFormInput} 
                leftLabelId={'lblem'+seq} leftLabelName={appDetailsData.label.em} 
                id={'em'+seq} name={'em'+seq} placeholder={'Please input'} maxLength={60} 
                disabled={oth.disabled} validator={emailValidator} />
        </div>
    )
}

export default PersonContactDetails